export const SET_COMPONENT_FIELD = 'SET_COMPONENT_FIELD';

export function setComponentField(key, value) {
    return { type: SET_COMPONENT_FIELD, key, value };
}
